import { render, staticRenderFns } from "./TheVisaAttachmentList.vue?vue&type=template&id=681ca19e&"
import script from "./TheVisaAttachmentList.vue?vue&type=script&lang=js&"
export * from "./TheVisaAttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports